import merge from 'lodash/merge'
import { useConfirmDialogContext } from '../useConfirmDialog/ConfirmDialogContext'

export const useAlertDialog = (config: Record<string, any> = {}) => {
  const ctx = useConfirmDialogContext()

  config = merge(
    {},
    {
      title: '',
      text: 'Please note of this!',
      icon: 'warning',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
        },
      },
      dangerMode: true,
    },
    config
  )

  const alert = (confirmConfig: any = {}) => {
    const alertConfig = merge({}, config, confirmConfig)
    return ctx.showDialog(alertConfig)
  }

  return { alert }
}
